import { isCancel } from 'axios'
import { requestAuthCodeEndpoint, csrfEndpoint } from './endpoints'
import { getRequest, postRequest } from './axiosBase'

let csrfRequest

export const getCsrfToken = async () => {
	if (csrfRequest?.cancel) {
		csrfRequest.cancel()
	}
	csrfRequest = getRequest(csrfEndpoint).then((response) => {
		const { token } = response
		return token
	})
	return csrfRequest
}

let requestAuthCodeRequest

export const requestAuthCode = async (email) => {
	if (requestAuthCodeRequest?.cancel) {
		requestAuthCodeRequest.cancel()
	}

	const csrfToken = await getCsrfToken()
	requestAuthCodeRequest = postRequest(
		requestAuthCodeEndpoint,
		{
			mail: email
		},
		{
			headers: {
				'X-CSRF-TOKEN': csrfToken
			}
		}
	)

	return requestAuthCodeRequest
}

let validateAuthCodeRequest
export const validateAuthCode = async (email, authCode) => {
	if (validateAuthCodeRequest) {
		validateAuthCodeRequest.cancel()
	}

	validateAuthCodeRequest = postRequest(requestAuthCodeEndpoint, {
		mail: email,
		secret: authCode
	})
	return validateAuthCodeRequest
}
